import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IVerifyPhoneNumberResponse,
  IVerifyPhoneNumberPayload,
} from "models/setting/verifyPhoneNumber";
import { httpStatus } from "configs/httpStatus";
import { verifyMobileNumber } from "services/setting";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./verifyPhoneNumberActions";

function* verifyPhoneNumberSaga({
  payload,
}: {
  payload: IVerifyPhoneNumberPayload;
}) {
  try {
    const response: IVerifyPhoneNumberResponse = yield call(
      verifyMobileNumber,
      payload
    );
    yield put(handleSuccessAction(response));
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onVerifyPhoneNumberSagaWatcher() {
  yield takeLatest(
    ActionType.VERIFY_PHONE_NUMBER as any,
    verifyPhoneNumberSaga
  );
}

export default [fork(onVerifyPhoneNumberSagaWatcher)];
